import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "../../constants/routeLink";
import { checkPercentMining, checkPercentMiningNo, claim, formatNumber } from '../../services/services';
import Loading from '../Loading';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
const Index = (props) => {
  const dispatch = useDispatch()
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const claim_ = async () => {
    setIsLoading(true);
    const res = await claim();
    if (res?.message) {
      toast(res.message)
    }
    setIsLoading(false);
  }
  return (

    <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2 zIndex-10'>
      <div className='card-custom w-100 p-3 radius-custom d-flex flex-column justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center'>
          <h4 className='text-white fs-extra d-flex m-0 mx-2'>{user?.profit?.toFixed(6)}</h4>

          <button className='btn btn-custom mt-1 scale_btn btn-balance p-0  '> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button>
        </div>

        <div className='d-grid justify-content-center align-items-center grid-3 mt-2 w-100'>
          {/* <div className='d-flex flex-column justify-content-center align-items-center'>
            <span className='text-white'>Earn per tap</span>
            <div className='d-flex justify-content-center align-items-center'>

              <span className='text-white fw-bold fs-2 mx-2'>2</span>
              <button className='btn btn-custom-sm mt-1 scale_btn btn-balance p-0'> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button>
            </div>
          </div> */}
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <span className='text-white'>Earn per day</span>
            <div className='d-flex justify-content-center align-items-center'>

              <span className='text-white fw-bold fs-2 mx-2'>{formatNumber(user?.balanceMining * checkPercentMining(user?.balanceMining) / (30 * 100))}</span>
              {/* <button className='btn btn-custom-sm mt-1 scale_btn btn-balance p-0'> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button> */}
            </div>
          </div>

          <div className='d-flex flex-column justify-content-center align-items-center'>

            <button disabled={isLoading} className='btn p-0 btn-custom-2 ppppsadasd' onClick={claim_}>

              {!isLoading && <span>Claim</span>}
              {isLoading && <Loading style={{ width: "20px", height: "20px" }} />}
            </button>
          </div>

          <div className='d-flex flex-column justify-content-center align-items-center'>
            <span className='text-white'>Ton upgrade</span>
            <div className='d-flex justify-content-center align-items-center'>

              <span className='text-white fw-bold fs-2 mx-2'>{formatNumber(user?.balanceMining)}</span>
              {/* <button className='btn btn-custom-sm mt-1 scale_btn btn-balance p-0'> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button> */}
            </div>
          </div>

        </div>
        <div style={{ color: '#fff', marginTop: 10 }}>
          <div onClick={() => {
            navigate(routeLink.HISTORY)
          }}>Historys{`>>>>>`}</div>
        </div>
      </div>


    </div>

  )
}

export default Index;
